import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { ArrowBackIos as ArrowBackIosIcon } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getItem, removeItem } from 'storage';
import PasswordTextField from 'components/Input/PasswordTextField';
import CustomButton from 'components/CustomInput/Button/index';
import { UPDATE_USER } from 'store/key';
// import { useSelector } from 'react-redux';
import API from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
        flex: 1,
        overflow: 'auto',
    },
    title: {
        fontWeight: 'bold',
        fontSize: '24px',
        paddingBottom: theme.spacing(4),
    },
    item: {
        marginTop: theme.spacing(2),
    },
    footer: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(1),
    },
}));

const FirstLogResetPassword = (props) => {
    const classes = useStyles();

    const { setPageComponent } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const currentRole = useSelector((state) => state.user.role);

    // const systemMessage = useSelector(state => state.systemMessage.systemMessage);

    const [formData, setFormData] = useState({
        password: {
            value: '',
            label: 'Password',
            name: 'password',
            type: 'password',
        },
        confirmPassword: {
            value: '',
            label: 'Confirm Password',
            name: 'confirmPassword',
            type: 'password',
        },
    });
    const [forceShowError, setForceShowError] = useState(false);
    const [passwordValid, setPasswordValid] = useState(true);
    const [confirmPasswordValid, setConfirmPasswordValid] = useState(true);

    const checkFormDataValid = () => {
        let isValid = true;
        for (let i in formData) {
            if (!formData[i].value) {
                isValid = false;
                break;
            }
        }
        return isValid;
    };

    const handleFormDataChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: {
                ...formData[name],
                value: value,
            },
        });
    };

    const confirm = () => {
        //update global state isLogin in user reducer
        setForceShowError(true);
        if (passwordValid && confirmPasswordValid && checkFormDataValid()) {
            setGlobalLoading(true);
            const token = getItem('SHOULD_UPDATE_TOKEN');
            API.user
                .changeFirstPassword({
                    passwordToken: token,
                    password: formData.password.value,
                    confirmPassword: formData.confirmPassword.value,
                })
                .then((res) => {
                    const { token, refreshToken } = res?.data?.result;

                    dispatch({
                        type: UPDATE_USER,
                        payload: {
                            isLogin: true,
                            accessToken: token,
                            refreshToken: refreshToken,
                            shouldUpdatePassword: false,
                            role: currentRole,
                        },
                    });
                    removeItem('SHOULD_UPDATE_TOKEN');
                    history.push('/');
                })
                .finally(() => {
                    setGlobalLoading(false);
                });
        }
    };

    const back = () => {
        dispatch({
            type: UPDATE_USER,
            payload: {
                isLoading: false,
                shouldUpdatePassword: false,
            },
        });
        setPageComponent('showLoginLayout');
    };

    const reset = () => {
        setFormData({
            ...formData,
            password: { ...formData.password, value: '' },
            confirmPassword: { ...formData.confirmPassword, value: '' },
        });
    };
    return (
        <Grid container wrap="nowrap" direction="column" className={classes.container}>
            <Grid container className={classes.title} style={{ fontSize: 18, fontWeight: 'bold' }}>
                You must reset password for the first login.
            </Grid>
            <Grid container alignItems="center" className={classes.item}>
                <Grid container direction="column">
                    <PasswordTextField
                        name="password"
                        label="Password"
                        value={formData.password.value}
                        handleChange={handleFormDataChange}
                        validators={['isRequired', 'disableChinese', 'checkPassword']}
                        isValidValue={(valid) => setPasswordValid(valid)}
                        forceErrorDisplay={forceShowError}
                        maxLength={255}
                    />
                </Grid>
            </Grid>
            <Grid container alignItems="center" className={classes.item}>
                <Grid container direction="column">
                    <PasswordTextField
                        name="confirmPassword"
                        label="Confirm Password"
                        value={formData.confirmPassword.value}
                        handleChange={handleFormDataChange}
                        validators={['isRequired', 'disableChinese', 'checkConfirmPassword']}
                        isValidValue={(valid) => setConfirmPasswordValid(valid)}
                        forceErrorDisplay={forceShowError}
                        confirmPasswordNotMatchPassword={formData.confirmPassword.value !== formData.password.value}
                        maxLength={255}
                    />
                </Grid>
            </Grid>
            <Grid container justify="space-between" className={classes.footer} wrap="nowrap">
                <Grid container item xs={3}>
                    <CustomButton fullWidth color="default" startIcon={<ArrowBackIosIcon />} onClick={back}>
                        Back
                    </CustomButton>
                </Grid>
                <Grid container item xs={3}>
                    <CustomButton fullWidth onClick={reset}>
                        Clear
                    </CustomButton>
                </Grid>
                <Grid container item xs={3}>
                    <CustomButton fullWidth onClick={confirm}>
                        Confirm
                    </CustomButton>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default FirstLogResetPassword;
